import { 
    Button,
    Modal, ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useDisclosure }
from "@chakra-ui/react";

import { BGMusic, playBGMusic } from './BGMusic';

export default function EasterEgg(){
        const { isOpen, onOpen, onClose } = useDisclosure()
        const BBLink = "https://www.beepbox.co/#9n31s0k0l00e00t2-a7g0fj07r1i0o432T1v3u65f0q0x10t51d08A1F2B9Q00d0Pfc47E3b662878T8v1u08f40x615d2h82gcqdr043022451d06x423W3E0T0v2u00f0qwx10p711d04w2h0E4c0a060707T3v3uf6f0qwx10n611d08SLXtHrrsksrzrrrrE1b6b4h400000000h4g000000014h000000004h400000000p22cGVuLnEd4aPhZb4qqfn8Td7WiUCni5AhleKnYgLqqDHU5qCFWYO0BWqfwLGpE-Cr8KyAzJ8W7J7Fru4o2nIQv59E-qo5cK3r0QR2UEhJeKnzoSyBFBZfeY0BWqcwOXOeCwLE8Td6iBF60"

        return (
          <>
            <Button onClick={onOpen} variant='ghost'>
                <Text fontSize={"4xl"} /* fontStyle={"italic"} */ fontFamily={"Magneto"}>?🐣?</Text>
            </Button>
      
            <Modal isOpen={isOpen} onClose={onClose} size="xl">
              <ModalOverlay />
              <ModalContent>
                <ModalHeader textAlign="center">🌈QCJam 2023 Bonus🌈</ModalHeader>
                <ModalCloseButton />
                <ModalBody textAlign="justify" p="20px">
                    <Text>The original design called for "adaptive music," hoping the music would change as the user/player progressed
                        through more direct writing prompts. The first few days, I tried to implement a library for audio in JavaScript,
                        which was new to me. With inconsistent results, and music that wasn't adding much, the idea was mostly dropped.
                        However, the new knowledge and the library were still in place.
                        <br/>
                        <br/>
                        At the <em>end</em> of the project, I found <a href={BBLink}>"Beepbox.co"</a>, a tool that
                        would make DIY layered music possible in my project. Of course, the discovery was too late, and too involved.
                        <br/>
                        <br/>
                        But I did lift myself up by making one loop, which you can hear below. Do what brings you small joys, make
                        compromises that bring you forward. 
                    </Text>
                </ModalBody>
                <ModalFooter justifyContent="center" gap={10}>
                       <Button onClick={playBGMusic}>🎧</Button>
                       <Button variant="outline" onClick={()=>BGMusic.stop()}>⏸️</Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </>
        )
      }